/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Feedback sentiment.
 */
export const Sentiment = {
  Up: "up",
  Down: "down",
} as const;
/**
 * Feedback sentiment.
 */
export type Sentiment = ClosedEnum<typeof Sentiment>;

export type SubmitRiskBlockFeedbackRequestBody = {
  /**
   * The block ID (the underlying risk result ID).
   */
  id: string;
  /**
   * Feedback sentiment.
   */
  sentiment: Sentiment;
};

/** @internal */
export const Sentiment$outboundSchema: z.ZodMiniEnum<typeof Sentiment> = z.enum(
  Sentiment,
);

/** @internal */
export type SubmitRiskBlockFeedbackRequestBody$Outbound = {
  id: string;
  sentiment: string;
};

/** @internal */
export const SubmitRiskBlockFeedbackRequestBody$outboundSchema: z.ZodMiniType<
  SubmitRiskBlockFeedbackRequestBody$Outbound,
  SubmitRiskBlockFeedbackRequestBody
> = z.object({
  id: z.string(),
  sentiment: Sentiment$outboundSchema,
});

export function submitRiskBlockFeedbackRequestBodyToJSON(
  submitRiskBlockFeedbackRequestBody: SubmitRiskBlockFeedbackRequestBody,
): string {
  return JSON.stringify(
    SubmitRiskBlockFeedbackRequestBody$outboundSchema.parse(
      submitRiskBlockFeedbackRequestBody,
    ),
  );
}
